import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const CommentIcon = ({ color = '#FFF', size = '14px', ...props }) => (
  <svg
    viewBox="0 0 24 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.65 0C5.338 0 .221 4.156.221 9.286c0 2.214.956 4.24 2.545 5.835C2.208 17.37.342 19.375.32 19.397a.355.355 0 0 0-.067.389.35.35 0 0 0 .326.214c2.96 0 5.178-1.42 6.276-2.295 1.46.55 3.08.866 4.795.866 6.313 0 11.429-4.156 11.429-9.285C23.079 4.156 17.963 0 11.65 0ZM5.936 10.714a1.427 1.427 0 1 1 0-2.857c.79 0 1.428.639 1.428 1.429s-.638 1.428-1.428 1.428Zm5.714 0a1.427 1.427 0 1 1 0-2.857c.79 0 1.429.639 1.429 1.429s-.639 1.428-1.429 1.428Zm5.714 0c-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0c0 .79-.638 1.428-1.429 1.428Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

CommentIcon.propTypes = propTypes;

export default CommentIcon;
